module.exports = {
  siteTitle: 'Plug | Make plans, invite friends', // <title>
  manifestName: 'Make plans, invite friends',
  manifestShortName: 'Landing Page', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/PlugLogo.png',
  pathPrefix: `/gatsby-starter-eventually/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  heading: 'Plug',
  subHeading:
    "Plug is a platform for friends to share invites to micro events or ‘plugs’. It is designed to create a new system for friends to invite each other to day-to-day activities as well as managing it all in one place.",
  socialLinks: [
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:admin@pluggo.app',
    },
  ],
};
